import {ELECTRICITY_CONTRACT_DATA_SESSION_STORAGE_KEY} from "../../../../electricity-contract-page/frontend/src/constants.js";

/**
 * The form data needs to be reset if the user clicks on any of the "I live.. in a house, in an apartment" links.
 * Otherwise the preset housing type might not be set as expected as the data would be fetched from the session storage.
 * Note the "reset-electricity-contract-form-data-onclick" class needs to be added to all the relevant links.
 */
export const enableResetElectricityContractFormDataOnClickListeners = () => {
    jQuery('.reset-electricity-contract-form-data-onclick').on('click', () => {
        sessionStorage.removeItem(ELECTRICITY_CONTRACT_DATA_SESSION_STORAGE_KEY);
    });
};
